export class Wrapper {
    static style1 = 'style1';
    static style2 = 'style2';
}